import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Grid from "@material-ui/core/Grid";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Zmage from "react-zmage";
import { GoujianCard } from "../listpage";

import SERVER_ADDRESS from "../../../../config";
import { ObjModel, DirectionLight } from "../../../../react-model-viewer";
import { Vector3 } from "three";

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  divider: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.light
  },
  typography: {
    marginTop: theme.spacing(4)
  },
  paper: {
    width: "100%",
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  zmage: {
    display: "inline-block",
    maxWidth: "100%"
  },

  goujianCard: {
    margin: theme.spacing(1)
  }
}));

//获取构件位置信息图
function useGoujianPosition(initValue, goujianId) {
  const [goujianPosition, setGoujianPosition] = useState(initValue);
  const fetchUrl = `${SERVER_ADDRESS}/api/goujianimages/?description=位置关系图&category=图纸&goujian__id=${goujianId}`;

  useEffect(() => {
    async function getGoujianPosition() {
      const goujianPosition = await fetch(fetchUrl, {
        mode: "cors",
        credentials: "include"
      }).then(res => {
        return res.json();
      });
      //使用第0张图,确保最早上传的位置构件图作为展示用
      setGoujianPosition(goujianPosition[0]);
    }
    getGoujianPosition();
  }, [goujianId]);
  return goujianPosition;
}

function GoujianBasic(props) {
  const classes = useStyles();
  const { goujianId, goujian, freshData } = props;
  //构件位置图
  const goujianPosition = useGoujianPosition({}, goujianId);
  return (
    <Grid
      container
      className={classes.paper}
      component={Paper}
      elevation={2}
      spacing={1}
    >
      {Object.keys(goujian).length !== 0 ? (
        <Grid item xs={12} md={3} style={{ height: "100%" }}>
          <GoujianCard
            goujian={goujian}
            freshData={freshData}
            className={classes.goujianCard}
            fullresMedia
            qrCode
          />
        </Grid>
      ) : null}

      <Grid item xs={12} md={5} style={{ height: "100%" }}>
        <Zmage
          src={goujianPosition.image}
          alt=""
          className={classes.zmage}
          backdrop="#333333"
        />
      </Grid>

      {Object.keys(goujian).length !== 0 ? (
        <Grid item xs={12} md={4} style={{ height: "100%" }}>
          <ObjModel
            src={goujian.obj_model}
            texPath=""
            position={{ x: 0, y: 0, z: 0 }}
          >
            <DirectionLight color="#AB9B7F" position={new Vector3(1, 0, 0)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(-1, 0, 0)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(0, 0, 1)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(0, 0, -1)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(0, 1, 0)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(0, -1, 0)} />
          </ObjModel>
        </Grid>
      ) : null}
    </Grid>
  );
}

export default GoujianBasic;
